import * as React from 'react';

import { MenuEntry } from '@europrocurement/flexy-components';
import TachesRoot from './views/TachesRoot';
import {
    listeDossierTachesPath,
    listeTiersTachesPath,
    listeUserTachesPath,
    tachesBasePath,
} from './constants/paths';
import { ListeTachesDossiers, ListeTachesPrescripeurs, ListeTachesUtilisateur } from './views';

export const TachesRouter = {
    path: tachesBasePath,
    element: <TachesRoot />,
    children: [
        {
            path: listeDossierTachesPath,
            element: <ListeTachesDossiers />,
        },
        {
            path: listeTiersTachesPath,
            element: <ListeTachesPrescripeurs />,
        },
        {
            path: listeUserTachesPath,
            element: <ListeTachesUtilisateur />,
        },
    ],
};

// Administration Sub-menu entry.
export const TachesMenuEntries: MenuEntry[] = [
    {
        title: 'Taches',
        icon: 'tasks',
        role: 'realm:interne',
        children: [
            {
                title: 'Taches liées aux dossiers',
                icon: 'folders',
                href: listeDossierTachesPath,
                role: 'realm:interne',
            },
            {
                title: 'Taches liées aux prescripteurs',
                icon: 'users',
                href: listeTiersTachesPath,
                role: 'realm:interne',
            },
            {
                title: 'Mes taches',
                icon: 'users',
                href: listeUserTachesPath,
                role: 'realm:interne',
            },
        ],
    },
];
